module.exports = __webpack_public_path__ + "img/TC11EE.344af374.svg";